<template>
    <div class="flex-row-wrap">

        <div class="w50">
            <div class="widget m10">
                <router-link class="title" :to="{name: 'artifact'}">
                    Artifcts
                    <i class="ico-mi icon-metrics-link"></i>
                </router-link>
                <div class="body">
                    <div class="metrics">
                        <div class="metric w50">
                            <span class="value">{{ artifacts.today }}</span>
                            <span class="label">today</span>
                        </div>
                        <div class="metric w50">
                            <span class="value">{{ artifacts.all }}</span>
                            <span class="label">all time</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="w50">
            <div class="widget m10">
                <router-link class="title" :to="{name: 'user'}">
                    Members
                    <i class="ico-mi icon-metrics-link"></i>
                </router-link>
                <div class="body">
                    <div class="metrics">
                        <div class="metric w50">
                            <span class="value">{{ users.today }}</span>
                            <span class="label">today</span>
                        </div>
                        <div class="metric w50">
                            <span class="value">{{ users.all }}</span>
                            <span class="label">all time</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: "Dashboard",
    data() {
        return {
            lang: this.$ml.get('dashboard'),

            artifacts: {
                all: 0,
                today: 0,
            },
            users: {
                all: 0,
                today: 0,
            },
        }
    },
    created() {
        axios
            .post(this.$store.getters.getApiUrl('dashboard'), {
                params: {
                    type: 'home'
                }
            })
            .then(({data}) => {
                this.artifacts = data.data.artifacts
                this.users = data.data.users
            })
    },
    mounted() {
        this.$store.commit('setDashboardTitle', this.lang.title)
    },
    methods: {}
}
</script>

<style scoped>

</style>
